export const companyTypeOptions = [
  { label: 'Pessoa física', value: 1 },
  { label: 'Pessoa jurídica', value: 2 },
  { label: 'Todos', value: 3 },
];

export const registrationStatusOptions = [
  { label: 'Ativos', value: 1 },
  { label: 'Inativos', value: 2 },
  { label: 'Todos', value: 3 },
];

export const crcStatusOptions = [
  { label: 'Válidos', value: 1 },
  { label: 'Vencidos', value: 2 },
  { label: 'Todos', value: 3 },
];

export const groupingByOptions = [
  {label: "Sem agrupamento", value: null},
  {label: "Agrupar por modalidade", value: 4},
  {label: "Agrupar por município", value: 5},
]
